"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _OffsetBox = require("./OffsetBox.helpers");
const useStyles = props => {
  const {
    position = 'bottom',
    isAttachedToWindow = false,
    offset = 5,
    anchorRef,
    boxRef,
    isOpen,
    anchorWidth = 'fit-content',
    isCenteredToAnchor
  } = props;
  const {
    direction = 'rtl'
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    viewHeight,
    viewWidth
  } = (0, _hooks.useDeviceData)();
  const [boxPosition, setBoxPosition] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    if (isOpen && anchorRef.current && boxRef.current) {
      const anchorRect = anchorRef.current.getBoundingClientRect();
      const boxRect = boxRef.current.getBoundingClientRect();
      let actualPosition = position;
      if (position === 'inline-start') {
        actualPosition = direction === 'rtl' ? 'right' : 'left';
      } else if (position === 'inline-end') {
        actualPosition = direction === 'rtl' ? 'left' : 'right';
      }
      const updatedBoxPosition = (0, _OffsetBox.getBoxPosition)({
        anchorRect,
        boxRect,
        position: actualPosition,
        direction,
        isAttachedToWindow,
        offset,
        viewHeight,
        viewWidth,
        isCenteredToAnchor
      });
      setBoxPosition(updatedBoxPosition);
    }
  }, [anchorRef, position, boxRef, direction, isAttachedToWindow, offset, viewHeight, isOpen, viewWidth, isCenteredToAnchor]);
  return {
    currentBoxPosition: boxPosition?.positionedOn,
    'cc-OffsetBox__anchor': (0, _css.css)({
      width: anchorWidth,
      display: 'flex',
      maxWidth: '100%'
    }),
    'cc-OffsetBox__box': (0, _css.css)({
      position: 'fixed',
      display: 'inline-block',
      zIndex: 9999,
      ...boxPosition
    })
  };
};
exports.useStyles = useStyles;